<template>
    <footer class="footer">
        <div class="container">
            <div class="copyright text-center">
              Copyright @ <a href="https://www.controlare.com.br" target="_blank">Controlare</a
            > {{ new Date().getFullYear() }}. Todos os direitos reservados.
          </div>
        </div>
      </footer>
</template>

<script>
  export default {};
</script>